import { render, staticRenderFns } from "./AlertSnackBar.vue?vue&type=template&id=0c7e71ee&scoped=true"
import script from "./AlertSnackBar.vue?vue&type=script&lang=js"
export * from "./AlertSnackBar.vue?vue&type=script&lang=js"
import style0 from "./AlertSnackBar.vue?vue&type=style&index=0&id=0c7e71ee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7e71ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c7e71ee')) {
      api.createRecord('0c7e71ee', component.options)
    } else {
      api.reload('0c7e71ee', component.options)
    }
    module.hot.accept("./AlertSnackBar.vue?vue&type=template&id=0c7e71ee&scoped=true", function () {
      api.rerender('0c7e71ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popups/AlertSnackBar.vue"
export default component.exports